// extracted by mini-css-extract-plugin
export default {"inspector":"styles_inspector__riW6g"};